import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SKELETON_COUNT = 6;
export const DrawerSkeletonRows = () => {
  return /*#__PURE__*/_jsx(View, {
    "aria-hidden": true,
    "data-test-id": "drawer-skeleton-rows",
    children: Array.from({
      length: SKELETON_COUNT
    }).map((_, idx) => /*#__PURE__*/_jsxs(View, {
      paddingBlock: "400",
      paddingInline: "300",
      children: [/*#__PURE__*/_jsx(View, {
        blockSize: "14px",
        inlineSize: "60%",
        backgroundColor: "fill-surface-recessed",
        borderRadius: "100"
      }), /*#__PURE__*/_jsx(View, {
        blockSize: "12px",
        inlineSize: "40%",
        backgroundColor: "fill-surface-recessed",
        borderRadius: "100",
        marginBlockStart: "200"
      })]
    }, idx))
  });
};